import moment from "moment";
import { dateTimeFormats } from "../utils/helper";
import http from "./httpService";

const baseUrl = `/statistics`;

// Public (no-auth) overview for the login page -> { totalMembers, totalCheckIns }.
export const getPublicOverview = async () => {
  try {
    const { data } = await http.get(`/public/overview`);
    return data;
  } catch (err) {
    return null;
  }
};

export const getShortHighlights = async () => {
  try {
    const { data } = await http.get(`${baseUrl}/short-highlights`);
    return data;
  } catch (err) {
    return null;
  }
};

export const getMissingCheckoutsOverview = async () => {
  try {
    const { data } = await http.get(`${baseUrl}/checkout/missing`);
    return data;
  } catch (err) {
    return null;
  }
};

// Members currently on a break right now -> { count, onBreak: [...] }
export const getActiveBreaks = async () => {
  try {
    const { data } = await http.get(`${baseUrl}/breaks/active`);
    return data;
  } catch (err) {
    return null;
  }
};

/**
 *
 * @param {string} date **format**: 'YYYY-MM-DD', **default**: today
 */
export const getListOfLateCheckInByDate = async (date = moment().format(dateTimeFormats.yearMonthDate)) => {
  try {
    const { data } = await http.get(`${baseUrl}/late-check-ins`, {
      params: {
        date,
      },
    });
    return data;
  } catch (err) {
    return null;
  }
};
